import React from 'react';

const NotefulContext = React.createContext({
    
});

export default NotefulContext;